const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-assets/shared/widget/multi-channel/dashboard-channel-selector-temporal");